import { render } from "./DashboardView.vue?vue&type=template&id=3e59cd91"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__